import React from 'react';
import { renderContentFromMetadata } from '@jutro/uiconfig';
import { Button } from '@jutro/components';
import SgCepLobSpecificUtil from 'sg-cep-lob-specific-util';
import metadata from './SgEndorsementPolicyTile.metadata.json5';

function SgEndorsementPolicyTile(props) {
    const {
        policy,
        setPolicyNumber
    } = props;

    const overrides = {
        endorsementPolicyHeader: {
            content: SgCepLobSpecificUtil.getAmendButtonLabelTop(policy)
        },
        endorsementPolicySubHeader: {
            content: policy.policyHeader.subHeader
        }
    };
    const resolvers = {};

    const baseStyle = 'sgMtaPolicyLink';
    const disable = policy.disabled ? `${baseStyle} sgDisabled` : baseStyle;
    return (
        <Button
            className={disable}
            onClick={() => {
                setPolicyNumber(policy.policyNumber);
            }}
        >
            <div className={`sgMtaPolicyIcon ${policy.productCode}`} />
            {renderContentFromMetadata(metadata.componentContent, overrides, resolvers)}
        </Button>
    );
}

export default SgEndorsementPolicyTile;
